import ReceiptSvg from '@assets/images/svg/receipt.svg';
import React from 'react';
import { View } from 'react-native';

export interface ReceiptIconProps {
    size?: number;
    color?: string;
}

export function ReceiptIcon({ size = 24, color = '#333333' }: ReceiptIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ReceiptSvg width={size} height={size} color={color} />
        </View>
    );
}

export default ReceiptIcon;
